<template>
    <vue-modal 
        :prefixCls="$prefixClass.modal" 
        v-model="isVisible"
        :header="false"
        :title="null" 
        :footer="null"
        :width="900"
        :centered="true"
        class="m-modal-rate-us"
    >
        <div class="rate-us good-rate">
            <div class="rate-us__content">
                <h3 class="m-b-16">{{ doneRate ? $t('app.rate_us.done_rate_title') : $t('app.rate_us.enjoy_swift') }}</h3>
                <p class="m-b-0">{{ doneRate ? $t('app.rate_us.done_rate_description') : $t('app.rate_us.enjoy_description') }}</p>
                <div  v-if="!doneRate && !changedRate" class="rating-app-wrap">
                    <a-rate :prefixCls="$prefixClass.rate" v-model="rateValue" @hoverChange="hoverChange" @change="rateUs" :allowClear="false"/>
                </div>
            </div>
            <div class="rate-us__img">
                <img class="p-l-80" src="@/assets/images/great.svg" />
            </div>
        </div>
        <div class="rate-us bad-rate hidden">
            <div class="rate-us__content">
                <h3 class="m-b-16">{{ $t('app.rate_us.keep_improving') }}</h3>
                <p class="m-b-0">{{ rateValue < 3 ? $t('app.rate_us.improving_description_one') : $t('app.rate_us.improving_description_two') }}</p>
                <div class="m-t-24">
                    <template v-if="rateValue < 3">
                        <a-button type="primary" @click="talkToUs">{{ $t('app.buttons.talk_to_us') }}</a-button>
                    </template>
                    <template v-else>
                        <a-button class="m-r-8" type="secondary" @click="talkToUs">{{ $t('app.buttons.talk_to_us') }}</a-button>
                        <a-button type="primary" @click="rateOnShopify">{{ $t('app.buttons.rate_on_shopify') }}</a-button>
                    </template>
                </div>
            </div>
            <div class="rate-us__img">
                <img class="p-l-100" src="@/assets/images/vote-bad.svg" />
            </div>
        </div>
    </vue-modal>
</template>
<script>
export default {
    name: 'VueModalRateUs',
    props: {
        value: {
            type: Boolean,
            required: true
        },
        href: String
    },
    data() {
        return {
            rateValue: 5,
            changedRate: false,
            doneRate: false
        }
    },
    computed: {
        isVisible: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        goodRate() {
            return this.rateValue == 5
        }
    },
    watch: {
        isVisible(value) {
            if ( value ) {
                setTimeout(() => {
                    this.doneRate = false
                    this.rateValue = 5
                    this.changedRate = false
                    this.goodRateReset()
                })
            }
        },
        deep: true
    },
    methods: {
        hoverChange(value) {
            this.changedRate = false
            if ( value ) {
                this.rateValue = value
            }
        },
        rateUs(value) {
            this.changedRate = true
            if ( this.goodRate ) {
                window.open(this.href, '_blank')
                this.doneRate = true
            } else {
                let goodRate = $('.good-rate')
                let badRate = $('.bad-rate')
                goodRate.addClass('hidden')
                goodRate.removeClass('visible')
                badRate.removeClass('hidden')
                badRate.addClass('visible')
            }
        },
        talkToUs() {
            this.isVisible = false
            //CONFIRM
            $crisp.push(['do', 'chat:open'])
            // $linebase.do('widget','open')
        },
        goodRateReset() {
            let goodRate = $('.good-rate')
            let badRate = $('.bad-rate')
            badRate.addClass('hidden')
            badRate.removeClass('visible')
            goodRate.removeClass('hidden')
            goodRate.addClass('visible')
        },
        rateOnShopify() {
            window.open(this.href, '_blank')
            this.goodRateReset()
            this.doneRate = true
        }
    }
}
</script>
<style lang="scss">
    .m-modal-rate-us {
        .m-modal-body {
            height: 254px;
            position: relative;
            overflow: hidden;
            padding: 0 !important;
        }
        .rate-us {
            display: flex;
            align-items: center;
            padding: 24px;
            &__content{
                flex: 1;;
            }
            &__img{
                flex: 1;
            }
            &.hidden {
                right: 100%;
            }
            &.visible {
                right: 0;
            }
            &.bad-rate {
                &.visible {
                    transition: 1s;
                }
            }
            &.good-rate, &.bad-rate {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
            }
            .rating-app-wrap {
                margin-top: 10px;
                .m-rate {
                    &-star {
                        font-size: 45px;
                        margin-right: 12px;
                    }
                    &-star-full {
                        svg {
                            fill: gold;
                        }
                        
                        &:hover {
                            -webkit-animation: aminate 1s;
                            -moz-animation: aminate 1s;
                            -o-animation: aminate 1s;
                            animation: aminate 1s;
                        }
                    }
                    &-star-zero {
                        svg {
                            fill: $white-color;
                            stroke: $line-color;
                            stroke-width: 20;
                        }
                    }
                    @keyframes aminate {
                        0% {
                            transform: scale(1);
                        }
                        25% {
                            transform: scale(1.5);
                        }
                        50% {
                            transform: scale(.9);
                        }

                        75% {
                            transform: scale(1.2);
                        }
                        100% {
                            transform: scale(1);
                        }
                    }
                    @-moz-keyframes aminate {
                        0% {
                            transform: scale(1);
                        }
                        25% {
                            transform: scale(1.5);
                        }
                        50% {
                            transform: scale(.9);
                        }

                        75% {
                            transform: scale(1.2);
                        }
                        100% {
                            transform: scale(1);
                        }
                    }
                    @-webkit-keyframes aminate {
                    0% {
                            transform: scale(1);
                        }
                        25% {
                            transform: scale(1.5);
                        }
                        50% {
                            transform: scale(.9);
                        }

                        75% {
                            transform: scale(1.2);
                        }
                        100% {
                            transform: scale(1);
                        }
                    }

                    @-o-keyframes aminate {
                        0% {
                            transform: scale(1);
                        }
                        25% {
                            transform: scale(1.5);
                        }
                        50% {
                            transform: scale(.9);
                        }

                        75% {
                            transform: scale(1.2);
                        }
                        100% {
                            transform: scale(1);
                        }
                    }

                    @-ms-keyframes aminate {
                        0% {
                            transform: scale(1);
                        }
                        25% {
                            transform: scale(1.5);
                        }
                        50% {
                            transform: scale(.9);
                        }

                        75% {
                            transform: scale(1.2);
                        }
                        100% {
                            transform: scale(1);
                        }
                    }
                }
            }
        }
    }
</style>